function StatusField({ statusString }: any) {
  const returnStatusColor = (text: string) => {
    switch (text && text?.toLowerCase()) {
      case "active":
      case "success":
      case "true":
      case "finished":
      case "completed":
      case "high":
        return {
          color: "var(--primary-900)",
          bg: "var(--primary-100)",
        };
      case "inactive":
      case "mapped":
      case "unmapped":
      case "low":
      case "false":
        return {
          color: "var(--warning-700)",
          bg: "var(--warning-100)",
        };
      case "moderate":
      case "approved":
        return {
          color: "var(--blue-700)",
          bg: "var(--blue-100)",
        };
      case "rejected":
      case "pending":
        return {
          color: "var(--warning-700)",
          bg: "var(--warning-100)",
        };
      default:
        return {
          color: "var(--warning-700)",
          bg: "var(--warning-100)",
        };
    }
  };

  return (
    <div
      style={{
        minWidth: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        padding: "6px 10px",
        fontWeight: 500,
        fontSize: 13,
        background: `${returnStatusColor(statusString).bg}`,
        color: returnStatusColor(statusString).color,
        textTransform: "capitalize",
      }}
    >
      {statusString}
    </div>
  );
}

export default StatusField;
